import { shallowMount } from "@vue/test-utils";
import ErrorBBVAVos from "@/views/ErrorBBVAVos";

describe("ErrorBBVAVos component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ErrorBBVAVos);
  });

  it("Renders del component ErrorBBVAVos", () => {
    expect(wrapper).toBeDefined();
  });
});
